// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","394":"component---src-pages-photography-js"}[chunkId] || chunkId) + "-" + {"108":"56bed31f647656d99f66","125":"11ff8d775fc9a4d2a563","293":"52a47e4f52acf7bcacc8","394":"29ecc51095a5285dc53c","452":"a9f9b247a5c5d8fba0ab"}[chunkId] + ".js";
};